export interface PublicOrgJoinBarVisibilityState {
  authReady: boolean;
  org: unknown | null;
  urlOrgSlug: string | null;
  isPublic: boolean;
  isMember: boolean;
  session: unknown | null;
  isLoading: boolean;
}

export function shouldRenderPublicOrgJoinBar({
  authReady,
  org,
  urlOrgSlug,
  isPublic,
  isMember,
  session,
  isLoading,
}: PublicOrgJoinBarVisibilityState): boolean {
  return Boolean(authReady && org && urlOrgSlug && isPublic && !isMember && !(session && isLoading));
}
